'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index$1 = require('../../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index = require('../../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var InternalCheckbox_web_styles = require('../../../../internal/InternalCheckbox/InternalCheckbox.web.styles.cjs');
var reactFontawesome = require('../../../../../react-fontawesome/react-fontawesome.cjs');
var Item_web_styles = require('../Item.web.styles.cjs');

/**
 * Subcomponent of Dropdown. The CheckboxItem is a selectable item within a DropdownMenu.
 *
 * @scope Web
 */ const CheckboxItem = ({ checked, disabled, children, ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsxs(index.CheckboxItem, {
        onSelect: (e)=>e.preventDefault(),
        css: Item_web_styles.item,
        "data-disabled": disabled,
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("span", {
                css: [
                    Item_web_styles.iconContainer
                ],
                children: /*#__PURE__*/ jsxRuntime.jsx("div", {
                    css: [
                        InternalCheckbox_web_styles.iconContainer.base,
                        checked && InternalCheckbox_web_styles.dropdownCheckboxItem,
                        disabled && InternalCheckbox_web_styles.iconContainer.disabled
                    ],
                    children: checked && /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                        icon: index$1.faCheck
                    })
                })
            }),
            children
        ]
    });
};
CheckboxItem.displayName = "DropdownMenu.CheckboxItem";

exports.CheckboxItem = CheckboxItem;
//# sourceMappingURL=CheckboxItem.web.cjs.map
